'use client';

import { c as _c } from "react/compiler-runtime";
import _ from 'lodash';
import { redirect } from 'next/navigation';
import { useEffect, useState } from 'react';
import AppleSignin from 'react-apple-signin-auth';
import { authApi } from '@/api';
import { Button } from '@/components';
import { appleClientId, pages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
import type { Auth } from '@/types/auth';

// https://github.com/a-tokyo/react-apple-signin-auth#readme
// Note: www.cruz.com only: not working on Localhost & UAT

type AppleResponse = {
  authorization: {
    id_token: string;
    code: string;
    state: string;
  };
  user?: {
    email: string;
    name: {
      firstName: string;
      lastName: string;
    };
  };
};
export function SignInWithApple(t0) {
  const $ = _c(18);
  const {
    afterSignInAction
  } = t0;
  const {
    user,
    setUser
  } = useGlobalStore(_temp);
  const [isWorking, setIsWorking] = useState(false);
  const [token, setToken] = useState("");
  let t1;
  if ($[0] !== setUser || $[1] !== token) {
    t1 = async function signIn() {
      setIsWorking(true);
      try {
        const d = await authApi.signInWithApple({
          token,
          client_id: appleClientId
        });
        setUser(d.data, null);
      } catch {
        setIsWorking(false);
      }
    };
    $[0] = setUser;
    $[1] = token;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const signIn = t1;
  let t2;
  if ($[3] !== afterSignInAction || $[4] !== isWorking || $[5] !== user) {
    t2 = () => {
      if (_.isEmpty(user) || !isWorking) {
        return;
      }
      setIsWorking(false);
      if (afterSignInAction) {
        afterSignInAction();
      } else {
        redirect(pages.myProfile.href);
      }
    };
    $[3] = afterSignInAction;
    $[4] = isWorking;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = user?._id;
  let t4;
  if ($[7] !== t3) {
    t4 = [t3];
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t2, t4);
  let t5;
  if ($[9] !== signIn || $[10] !== token) {
    t5 = () => {
      if (!_.isEmpty(token)) {
        signIn();
      }
    };
    $[9] = signIn;
    $[10] = token;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== token) {
    t6 = [token];
    $[12] = token;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      clientId: appleClientId,
      scope: "email name",
      usePopup: true,
      redirectURI: "https://www.cruz.com/auth/sign-in"
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = response => {
      setToken(response?.authorization?.id_token);
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isWorking) {
    t9 = <AppleSignin authOptions={t7} uiType="light" onSuccess={t8} onError={_temp2} render={props => <Button type="button" variant="outline" className="btn-signin" {...props} working={isWorking}><img src="/img/apple-logo-128.png" className="mr-3 w-5 dark:hidden" alt="Apple" /><img src="/img/apple-logo-128-reverse.png" className="mr-3 hidden w-5 dark:inline-block" alt="Apple" />Sign in with Apple</Button>} />;
    $[16] = isWorking;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp2(error) {
  console.error("Apple Sign-In Error:", error);
}
function _temp(state) {
  return state;
}